import Enum from './enum'

class UserAccreditationState extends Enum
{
  constructor(value) {
    super(value);
  }
}

UserAccreditationState.init({
  ACTIVE: 'Active',
  UNAUTHORIZED: 'Unauthorized',
  HAS_ACCREDITATION: 'Accreditate'
}, {
  ACTIVE: 'user-accreditation-state.active',
  UNAUTHORIZED: 'user-accreditation-state.unauthorized',
  HAS_ACCREDITATION: 'user-accreditation-state.has-accreditation'
});

export default UserAccreditationState;
